import { AuthService } from "@js/services/AuthService";
import { CaseService } from "@js/services/CaseService";
import { RoleService } from "@js/services/RoleService";
import { SelectListService } from "@js/services/SelectListService";
import { UserService } from "@js/services/UserService";
import {
  ApplicantRoleEnum,
  ApplicationUser,
  ApplicationUserCrudClient,
  AppPackagePricing,
  CaseClient,
  CaseMemberClient,
  Client,
  ClientClient,
  DealClient,
  DealClientClient,
  DevelopmentInput,
  DevelopmentInputClient,
  DevelopmentInputWithNoLogin,
  DevelopmentInputWithNoLoginClient,
  FileAttachmentClient,
  Introducer,
  InviteClient,
  LenderResult,
  LenderResultClient,
  OrganisationClient,
  PaymentClient,
  ProductFamilyEnum,
  ReferrerEnum,
  UserClient,
} from "@src/apis/ModularClient";
import { FileAttachmentHelper } from "@js/helpers/FileAttachmentHelper";
import { Expand, getOneUsingOData } from "@ccq/ts-lib";
import { IndexService } from "@js/services/IndexService";
import { ODataHelper } from "@js/helpers/ODataHelper";

export class RegistrationController {
  dataLoading: boolean = false;

  openModal: boolean = false;

  registeringAccount: boolean;
  registrationFormStep1: ng.IFormController;
  registrationFormStep2: ng.IFormController;

  error: string;
  passworderror: string;

  loanCriteria: DevelopmentInput;
  selectedResult: LenderResult;
  loanLabel: string = "";

  enquireAfterRegistration: boolean;

  newIntroducer: Introducer;

  //newUser: RegistrationRequestDTO = {
  //    Email: "", FirstName: "", LastName: ""
  //} as RegistrationRequestDTO;

  newUser: Expand<ApplicationUser> = {} as ApplicationUser;
  password: string = null;

  inviteGuid: string = "";
  step: number = 1;
  profileLogo: string;
  selectedPackage: AppPackagePricing;
  selectedProductList: AppPackagePricing[] = [];
  isPayClicked: boolean = false;

  isConvertingExistingUser: boolean = false;

  redirectToSearch: boolean = false;

  isShareholderRegistration: boolean = false;

  referrerOptions = [];
  locationOptions = [];

  showTsAndCs: boolean = false;
  showPrivacyPolicy: boolean = false;
  orgCode: string;
  productFamily: ProductFamilyEnum;

  registeringBroker: boolean = false;

  static $inject = [
    "CaseService",
    "$scope",
    "$rootScope",
    "$routeParams",
    "$cookies",
    "$location",
    "$http",
    "$httpParamSerializerJQLike",
    "LenderResultClient",
    "UserService",
    "AuthService",
    "RoleService",
    "CaseMemberClient",
    "CaseService",
    "CaseClient",
    "InviteClient",
    "OrganisationClient",
    "FileAttachmentClient",
    "FileAttachmentHelper",
    "DevelopmentInputClient",
    "PaymentClient",
    "DevelopmentInputWithNoLoginClient",
    "SelectListService",
    "ClientClient",
    "DealClient",
    "PaymentClient",
    "DealClientClient",
    "UserClient",
    "ApplicationUserCrudClient",
    "IndexService",
    "ODataHelper",
  ];

  constructor(
    private $CaseService: CaseService,
    private $scope: ng.IScope,
    private $rootScope: ng.IRootScopeService,
    private $routeParams: ng.route.IRouteParamsService,
    private $cookies: ng.cookies.ICookiesService,
    private $location: ng.ILocationService,
    private $http: ng.IHttpService,
    private $httpParamSerializerJQLike: ng.IHttpParamSerializer,
    private lenderResultClient: LenderResultClient,
    private $user: UserService,
    private $auth: AuthService,
    private $roleService: RoleService,
    private caseMemberClient: CaseMemberClient,
    private caseService: CaseService,
    private caseClient: CaseClient,
    private inviteClient: InviteClient,
    private organisationClient: OrganisationClient,
    private fileAttachmentClient: FileAttachmentClient,
    private fileAttachmentHelper: FileAttachmentHelper,
    private developmentInputClient: DevelopmentInputClient,
    private paymentClient: PaymentClient,
    private developmentInputWithNoLoginClient: DevelopmentInputWithNoLoginClient,
    private selectListService: SelectListService,
    private clientClient: ClientClient,
    private dealClient: DealClient,
    private $paymentClient: PaymentClient,
    private $dealClientClient: DealClientClient,
    private $userClient: UserClient,
    private applicationUserCrudClient: ApplicationUserCrudClient,
    private indexService: IndexService,
    private odataHelper: ODataHelper,
  ) {
    // If the user is from security web, prepopulate the information
    if (
      this.$location.path().startsWith("/registershareholder") ||
      this.$routeParams.uniqueId ||
      this.$location.path().startsWith("/bridgingregistershareholder") ||
      this.$location.path().startsWith("/dealregistershareholder")
    ) {
      this.isShareholderRegistration = true;

      if (
        this.$location.path().startsWith("/bridgingregistershareholder") ||
        this.$location.path().startsWith("/dealregistershareholder")
      ) {
        this.$dealClientClient.fetchDealClientByUniqueId(this.$routeParams.uniqueId).then((response) => {
          if (response.isVerified) {
            this.$location.path("/login");
          } else {
            this.odataHelper
              .getOne(this.applicationUserCrudClient, {
                filter: {
                  email: {
                    eq: response.client.email,
                  },
                },
                select: { id: true },
              })
              .then((userId) => {
                if (userId != null) {
                  (this.$rootScope as any).loginRedirectPath = "/dealsecuritycheck/" + this.$routeParams.uniqueId;
                  this.$location.path("/login");
                } else {
                  this.newUser.email = response.client.email;
                  this.newUser.firstName = response.client.firstName;
                  this.newUser.lastName = response.client.lastName;
                  this.newUser.phoneNumber = response.client.phoneNumber;
                  this.newUser.orgUniqueRef = this.$routeParams.brokerOrgUniqueRef;
                  this.newUser.dealClientUniqueRef = this.$routeParams.uniqueId;
                }
              });
          }
        });
      } else {
        this.caseMemberClient
          .fetchCaseMemberAndReturnRegisterInformation(this.$routeParams.uniqueId)
          .then((response) => {
            if (response.isVerified) {
              this.$location.path("/login");
            } else {
              this.odataHelper
                .getOne(this.applicationUserCrudClient, {
                  filter: {
                    email: {
                      eq: response.email,
                    },
                  },
                  select: { id: true },
                })
                .then((userId) => {
                  if (userId != null) {
                    (this.$rootScope as any).loginRedirectPath = "/securitycheck/" + this.$routeParams.uniqueId;
                    this.$location.path("/login");
                  } else {
                    this.newUser.email = response.email;
                    this.newUser.firstName = response.firstName;
                    this.newUser.lastName = response.surname;
                    this.newUser.phoneNumber = response.phoneNumber;
                    this.newUser.orgUniqueRef = this.$routeParams.brokerOrgUniqueRef;
                  }
                });
            }
          });
      }
    }

    // if the user is coming through this path, it is a broker invited by organisation to join it.
    if (this.$location.path().startsWith("/registerbroker")) {
      this.newUser.orgUniqueRef = this.$routeParams.uniqueRef;
      this.registeringBroker = true;
      (this.$rootScope as any).openWelcomeBrokerModal = true;
      //console.log((this.$rootScope as any).openWelcomeBrokerModal);
    }

    // If a broker invited the user to the platform we assign this broker org on the new user Organisation Referral Id.
    if (this.$location.path().startsWith("/registerborrower")) {
      this.newUser.orgUniqueRef = this.$routeParams["brokerOrgUniqueRef"];
    }
    // if the user is coming through this path, it is a borrower wanting to view a search but they must register first
    else if (
      (this.$location.path().startsWith("/registerwithsearch") && this.$routeParams["brokerOrgUniqueRef"]) ||
      (this.$location.path().startsWith("/registerwithbridgingsearch") && this.$routeParams["brokerOrgUniqueRef"]) ||
      (this.$location.path().startsWith("/registerwithdeal") && this.$routeParams["brokerOrgUniqueRef"])
    ) {
      this.newUser.orgUniqueRef = this.$routeParams["brokerOrgUniqueRef"];
    }

    if (
      (this.$location.path().startsWith("/registerwithbridgingsearch") && this.$routeParams["dealclientuniqueref"]) ||
      (this.$location.path().startsWith("/registerwithdeal") && this.$routeParams["dealclientuniqueref"])
    ) {
      this.newUser.dealClientUniqueRef = this.$routeParams["dealclientuniqueref"];
      this.dealClient.fetchProductFamilyByClientUniqueRef(this.$routeParams["dealclientuniqueref"]).then((response) => {
        this.productFamily = response;
      });
    }

    // If we have an introducer code set, let's store a cookie.
    if (this.$routeParams.introducercode) {
      var expiryDate = new Date();
      expiryDate.setDate(expiryDate.getDate() + 100);
      this.$cookies.put("introducer_code", this.$routeParams.introducercode, {
        expires: expiryDate,
      });
    } else if (this.$routeParams["ic"]) {
      var expiryDate = new Date();
      expiryDate.setDate(expiryDate.getDate() + 100);
      this.$cookies.put("introducer_code", this.$routeParams["ic"], {
        expires: expiryDate,
      });
    }

    if (this.$routeParams["orgc"]) {
      var expiryDate = new Date();
      expiryDate.setDate(expiryDate.getDate() + 100);
      this.$cookies.put("org_code", this.$routeParams["orgc"], {
        expires: expiryDate,
      });
    }

    if (location.pathname.replace("/", "") != null && location.pathname.replace("/", "").length > 0) {
      this.orgCode = location.pathname.replace("/", "");
    }

    if (this.$routeParams["invite"]) {
      this.inviteGuid = this.$routeParams["invite"];
    }

    this.loanCriteria = (this.$rootScope as any).loanCriteria;

    if (this.$routeParams.enquire !== undefined) {
      this.enquireAfterRegistration = true;
    }

    if (this.$cookies.get("access_token")) {
      this.getCurrentUser().then((result) => {
        this.newUser = result;

        if (this.newUser.isLegacyUser) {
          this.isConvertingExistingUser = true;

          this.newUser.isOrganisationAdmin = false;
          this.newUser.applicantDefinedRole = ApplicantRoleEnum.Developer;
          this.newUser.applicantDefinedRoleIntroducer = null;
        } else {
          this.$roleService.goHomeBasedOnUser();
        }
      });
    } else {
      if (this.$routeParams["noLoginUniqueRef"]) {
        this.redirectToSearch = true;
        this.developmentInputWithNoLoginClient
          .fetchDataByUniqueId(this.$routeParams["noLoginUniqueRef"])
          .then((noLoginSearchDto: DevelopmentInputWithNoLogin) => {
            if (noLoginSearchDto) {
              if (noLoginSearchDto.isDeleted) {
                this.redirectToSearch = false;
                sessionStorage.setItem("returningFromdeletedSearch", "true");
              }
              this.newUser.firstName = noLoginSearchDto.introduceeFirstName;
              this.newUser.lastName = noLoginSearchDto.introduceeSurname;
              this.newUser.email = noLoginSearchDto.introduceeEmail;
              this.newUser.phoneNumber = noLoginSearchDto.introduceePhone;
            }
          });
      } else if (
        (this.$location.path().startsWith("/registerwithbridgingsearch") && this.$routeParams["dealclientuniqueref"]) ||
        (this.$location.path().startsWith("/registerwithdeal") && this.$routeParams["dealclientuniqueref"])
      ) {
        this.redirectToSearch = true;
        this.clientClient
          .fetchByDealClientUniqueRef(this.$routeParams["dealclientuniqueref"])
          .then((clientDto: Client) => {
            if (clientDto) {
              if (clientDto.isDeleted) {
                this.redirectToSearch = false;
                sessionStorage.setItem("returningFromdeletedSearch", "true");
              }
              this.newUser.firstName = clientDto.firstName;
              this.newUser.lastName = clientDto.lastName;
              this.newUser.email = clientDto.email;
              this.newUser.phoneNumber = clientDto.phoneNumber;
            }
          });
      } else {
        if (!this.newUser) this.newUser = {} as ApplicationUser;
        //Grab details to prefill from lender results page
        this.newUser.firstName = (this.$rootScope as any).newUserFirstName;
        this.newUser.lastName = (this.$rootScope as any).newUserSurname;
        this.newUser.email = (this.$rootScope as any).newUserEmail;
      }

      this.newUser.applicantDefinedRole = (this.$rootScope as any).newUserRole;

      if (this.$location.path().startsWith("/registerbroker") && this.$routeParams.uniqueRef !== undefined) {
        this.newUser.applicantDefinedRole = ApplicantRoleEnum.Introducer;
        this.newUser.applicantDefinedRoleIntroducer = 3;
      }

      if (sessionStorage.getItem("userDetails")) {
        let data = sessionStorage.getItem("userDetails");
        let userdetails = JSON.parse(data);

        let userFullName = userdetails.FullName;
        let spaceIndex = userFullName.indexOf(" ");

        let firstName = "";
        let lastName = "";

        // if not space has been added to the name then put the whole name in the first name field
        if (spaceIndex == -1) {
          firstName = userFullName;
        } else {
          firstName = userFullName.substring(0, userFullName.indexOf(" "));
          lastName = userFullName.substring(userFullName.indexOf(" ") + 1);
        }

        this.newUser.firstName = firstName;
        this.newUser.lastName = lastName;
        this.newUser.email = userdetails.Email;
        this.newUser.phoneNumber = userdetails.PhoneNumber;
      }
    }

    if (sessionStorage.getItem("selectedPackage") && sessionStorage.getItem("selectedPackage") != "undefined") {
      let data = sessionStorage.getItem("selectedPackage");
      this.selectedPackage = JSON.parse(data);
    }

    this.referrerOptions = this.selectListService.GetReferrerOptions();
    this.locationOptions = this.selectListService.GetLocations();
  }

  private async getCurrentUser() {
    return await getOneUsingOData(this.applicationUserCrudClient, {
      filter: { id: { eq: await this.indexService.currentUserId } },
    });
  }

  registerAccount() {
    this.registeringAccount = true;
    this.dataLoading = true;
    this.isPayClicked = true;
    if (!this.isConvertingExistingUser && (this.newUser as any).confirmPassword !== this.password) {
      this.error = "Passwords do not match";
      this.dataLoading = false;
      this.isPayClicked = false;
    } else {
      //If has already agreed to terms, let's set this in the new user record
      if ((this.$rootScope as any).lenderResultsIntroSeen === true) {
        this.newUser.lenderResultsTermsAgreed = true;
      }

      this.newUser.userName = this.newUser.email; //set user name to be same as email address for now

      // If we have an org code, let's set it.
      if (this.$cookies.get("org_code")) {
        this.newUser.orgCode = this.$cookies.get("org_code");
      }
      // If we have an introducer code, let's set it.
      if (this.$cookies.get("introducer_code")) {
        this.newUser.introducerCode = this.$cookies.get("introducer_code");
        this.userRegistration();
      } else {
        this.inviteClient.checkIfRegisterUserWasInvited(this.newUser.email, this.inviteGuid).then((result) => {
          this.newUser.introducerCode = result;
          this.userRegistration();
        });
      }
    }
  }

  async userRegistration() {
    // send registration
    // Register Broker User
    if (this.registeringBroker != null && this.registeringBroker) {
      this.organisationClient
        .registerBroker(this.newUser.orgUniqueRef, this.newUser as ApplicationUser)
        .then((user) => {
          this.login(user);
        })
        .catch((response) => {
          this.error = response.data.Message;
          this.registeringAccount = false;
          this.dataLoading = false;
        })
        .finally(() => {
          this.registeringAccount = false;
        });
    } else {
      if (this.inviteGuid != null && this.inviteGuid.length > 0) {
        this.newUser.inviteCode = this.inviteGuid;
      }

      // Register Client User
      try {
        this.newUser.oidcId = this.newUser.email;
        this.newUser.name = this.newUser.email;
        const user = await this.$userClient.clientRegistration({
          user: this.newUser as ApplicationUser,
          password: this.password,
          inviteCode: this.newUser.inviteCode,
          dealClientUniqueRef: this.newUser.dealClientUniqueRef,
          orgUniqueRef: this.newUser.orgUniqueRef,
        });

        if (!user) {
          this.error = "An error occurred while creating the user";
        }

        // clean up session storage
        sessionStorage.removeItem("userDetails");
        sessionStorage.removeItem("clientId");
        sessionStorage.removeItem("userRole");
        sessionStorage.removeItem("projectname");

        if (this.$cookies.get("access_token") && this.isConvertingExistingUser) {
          // clear and reset cached data based on the new information

          this.$roleService.GetUserRoles(true); //reset user roles

          sessionStorage.setItem("isUpgradedUser", "true");

          this.onRegistrationComplete();
        } else if (!this.$cookies.get("access_token")) {
          this.login(user);
        } else {
          this.error = "logged in but not converting an existing user";
          this.registeringAccount = false;
          this.dataLoading = false;
        }
      } catch (error) {
        this.error = error.response;
        this.registeringAccount = false;
        this.dataLoading = false;
      } finally {
        this.registeringAccount = false;
      }
    }
  }

  login(user: ApplicationUser) {
    (this.$rootScope as any).selectedUser = user;
    if (!this.$cookies.get("access_token")) {
      this.$auth
        .newLogin(this.newUser.email, this.password, "CC022EBE67BE0424EA2A6548B062D2D71")
        .then((response) => {
          this.$userClient.getCurrentUser().then((response) => {
            (this.$rootScope as any).currentUser = response;
          });

          let expiry: Date = response;

          this.$cookies.put("user_firstname", user.firstName, {
            expires: expiry,
          });

          if (
            (this.$location.path().indexOf("/registerwithsearch") !== -1 && this.$routeParams["noLoginUniqueRef"]) ||
            (this.$location.path().indexOf("/registerwithbridgingsearch") !== -1 &&
              this.$routeParams["dealclientuniqueref"]) ||
            (this.$location.path().indexOf("/registerwithdeal") !== -1 && this.$routeParams["dealclientuniqueref"])
          ) {
            if (this.$routeParams["noLoginUniqueRef"]) {
              var url = "/referredSearch/" + this.$routeParams["noLoginUniqueRef"];
              if (this.$routeParams["brokerOrgUniqueRef"] && this.$routeParams["brokerUserId"]) {
                url += "/" + this.$routeParams["brokerOrgUniqueRef"] + "/" + this.$routeParams["brokerUserId"];
              }
            } else if (this.$routeParams["searchId"]) {
              var url = "/bridgingresults/" + this.$routeParams["searchId"];
              if (this.$routeParams["brokerOrgUniqueRef"] && this.$routeParams["brokerUserId"]) {
                url += "/" + this.$routeParams["brokerOrgUniqueRef"] + "/" + this.$routeParams["brokerUserId"];
              }
            } else if (this.$routeParams["dealclientuniqueref"]) {
              switch (this.productFamily) {
                case ProductFamilyEnum.Bridging:
                  var url = "/referredsearchdeal/" + this.$routeParams["dealclientuniqueref"];
                  break;
                case ProductFamilyEnum.Commercial:
                  var url = "/referredsearchcommercial/" + this.$routeParams["dealclientuniqueref"];
                  break;
                case ProductFamilyEnum.Development:
                  var url = "/referredsearchdevfinance/" + this.$routeParams["dealclientuniqueref"];
                  break;
                default:
                  var url = "/referredsearchdeal/" + this.$routeParams["dealclientuniqueref"];
                  break;
              }
              //if (this.$routeParams['brokerOrgUniqueRef'] && this.$routeParams['brokerUserId']) {
              //    url += "/" + this.$routeParams['brokerOrgUniqueRef'] + "/" + this.$routeParams['brokerUserId'];
              //}
            }

            if (this.redirectToSearch) {
              this.$location.path(url);
            } else {
              this.$location.path("/userdashboard");
            }
          } else if (
            this.loanCriteria &&
            !(
              this.loanCriteria.cI_Dev_OrigPP == 0 &&
              this.loanCriteria.cI_EndPropType == 0 &&
              this.loanCriteria.cI_GDV == 0 &&
              this.loanCriteria.cI_Dev_LoanReq == 0
            )
          ) {
            if (this.selectedPackage) {
              this.selectedProductList.push(this.selectedPackage);
              this.createCheckoutSession();
            } else {
              this.loanCriteria.userId = user.id;
              this.loanCriteria.user = user;
              this.loanCriteria.saveQueryAndResults = true;
              var lenderName: string = "";
              if (this.selectedResult != null) {
                lenderName = this.selectedResult.lenderName;
                this.loanLabel = this.selectedResult.loanLabel;
              }

              this.lenderResultClient
                .productsOfferingLargestLoanAndMatching(
                  true,
                  true,
                  4,
                  false,
                  "",
                  user.email,
                  user.phoneNumber,
                  lenderName,
                  true,
                  this.loanCriteria,
                )
                .then((response) => {
                  if (this.loanCriteria.saveCase === true) {
                    //case creation
                    this.caseClient
                      .promoteSearchToCase(
                        response.id,
                        (this.$rootScope as any).selectedResultForAttachingToCase.Id,
                        (this.$rootScope as any).productResultList,
                      )
                      .then((response) => {
                        this.$location.path("/userdashboard");
                      });
                  } else {
                    this.$location.path("/userdashboard");
                  }
                });
            }
          } else if (this.$routeParams.uniqueId) {
            if (
              this.$location.path().startsWith("/bridgingregistershareholder") ||
              this.$location.path().startsWith("/dealregistershareholder")
            ) {
              this.$location.path("/dealsecuritycheck/" + this.$routeParams.uniqueId);
            } else {
              this.$location.path("/securitycheck/" + this.$routeParams.uniqueId);
            }
          } else if (this.$location.path().indexOf("/startprojectappraisal") !== -1) {
            this.createNewBlankCase();
          } else if (this.$location.path().indexOf("/applyfordevloan") !== -1) {
            this.createNewBlankCase(true);
          } else {
            this.onRegistrationComplete();
          }

          if (this.enquireAfterRegistration) {
            // Send enquiry and pop up?
          }
        })
        .finally(() => {
          this.dataLoading = false;
        });
    } else {
      this.$roleService.goHomeBasedOnUser();
      this.dataLoading = false;
    }
  }

  onRegistrationComplete() {
    if (this.selectedPackage) {
      this.selectedProductList.push(this.selectedPackage);
      this.createCheckoutSession();
    } else {
      if (this.redirectToSearch) {
        var url = "/referredSearch/" + this.$routeParams["noLoginUniqueRef"];
        if (this.$routeParams["brokerOrgUniqueRef"] && this.$routeParams["brokerUserId"]) {
          url += "/" + this.$routeParams["brokerOrgUniqueRef"] + "/" + this.$routeParams["brokerUserId"];
        }

        this.$location.path(url);
      } else {
        this.$location.path("/userdashboard");
      }
    }
  }

  change() {
    if (!this.isConvertingExistingUser) {
      if ((this.newUser as any).confirmPassword === this.password) {
        this.passworderror = "";
      } else {
        this.passworderror = "Passwords do not match";
      }
    }
  }

  emailChange() {
    if (this.error) {
      this.error = "";
    }
  }

  clearRegistration() {
    this.registeringAccount = false;
  }

  go(path): void {
    this.$location.path(path);
  }

  async createNewBlankCase(applyForDevLoan: boolean = false) {
    this.$roleService.GetUserRoles().then((result) => {
      var isPrimaryApplicant: boolean = true;

      if (result.filter((x) => x == "Broker").length > 0) {
        isPrimaryApplicant = false;
      }

      this.caseService.newBlankCase(isPrimaryApplicant).then((newBlankCaseDto) => {
        // If applying for a development loan then go to the case dashboard of the new case
        if (applyForDevLoan == true) {
          this.$location.path("/casedashboard/" + newBlankCaseDto.NewCaseId);
        } else {
          // If starting a project appraisal then go directly to the appraisal module of the new case
          this.$location.path("/criteriaappraisal/" + newBlankCaseDto.NewCaseId + "/" + newBlankCaseDto.NewSearchId);
        }
      });
    });
  }

  fillRegisterForm() {
    let name = new Date().toLocaleString().replace(/ |,|:|\/|/g, "");
    this.newUser.email = `${name}@test.com`;
    this.newUser.firstName = name;
    this.newUser.lastName = "t";
    this.newUser.phoneNumber = "12345677";
    this.newUser.location = 1;
    this.newUser.applicantDefinedRole = 0;
    this.newUser.referrer = 1;
    this.password = "test";
    (this.newUser as any).confirmPassword = "test";
  }

  next() {
    this.step++;
  }

  back() {
    this.step--;
  }

  changeProfileLogo(files) {
    if (files.length > 0) {
      this.fileAttachmentHelper.uploadFileAndReturnURI(files).then((result) => {
        if (result) {
          this.newUser.profilePictureUrl = result.fileLocation;
          this.getLogoURL(this.newUser.profilePictureUrl);
        }
      });
    }
  }

  getLogoURL(url: string) {
    this.fileAttachmentClient.getAmazonFileAccessUri(url).then((result) => {
      this.profileLogo = result;
      //console.log(this.profileLogo);
    });
  }

  isFirstStepValid() {
    if (
      !this.registrationFormStep1.$invalid &&
      !(this.newUser.referrer == ReferrerEnum.Other && this.newUser.referrerOther == null)
    ) {
      return true;
    } else {
      return false;
    }
  }

  isSecondStepValid() {
    if (
      !this.registrationFormStep2.$invalid &&
      this.newUser.agreedToTermsAndPP === true &&
      !this.passworderror &&
      !this.registeringAccount &&
      !this.dataLoading
    ) {
      return true;
    } else {
      return false;
    }
  }

  createCheckoutSession() {
    //this.selectedProductList[0].SelectedModuleAppFeature = this.moduleAppFeatures;
    // Need to save the search so we can get back to it after payment ($rootscope will lose the data)
    if ((this.$rootScope as any).loanCriteria != null) {
      (this.$rootScope as any).loanCriteria.UserId = (this.$rootScope as any).selectedUser.Id;
      (this.$rootScope as any).loanCriteria.BrokerOrganisationId = (this.$rootScope as any).selectedUser.OrganisationId;
      this.developmentInputClient
        .saveSearch((this.$rootScope as any).loanCriteria)
        .then((developmentInputId: number) => {
          this.$paymentClient
            .createCheckoutSession(true, "", this.selectedPackage, developmentInputId)
            .then((response) => {
              window.location.assign(response.sessionUrl);
            });
        });
    } else {
      this.$paymentClient.createCheckoutSession(true, "", this.selectedPackage, null).then((response) => {
        window.location.assign(response.sessionUrl);
      });
    }
  }

  cancelCheckout() {
    if ((this.$rootScope as any).loanCriteria) {
      this.$location.path("/results");
    } else {
      this.$location.path("/userdashboard");
    }
  }

  getApplicationName() {
    if (sessionStorage.getItem("applicationName") != null) {
      return sessionStorage.getItem("applicationName");
    } else {
      return "Brickflow";
    }
  }
}
